export default "__VITE_ASSET__Ba3cf2MN__"